module.exports = __webpack_public_path__ + "img/m3.da26336c.jpg";